<template>
  <el-container style="min-height: 100vh">
    <el-header class="header flex ju-sp al-cn">
      <div class="flex ju-sp al-cn type-center cg-flex-shrink0">
        <div class="flex al-cn cg-flex-shrink0">
          <div class="logo cg-flex-shrink0">
            <img src="@/assets/slices/logo.png" alt />
          </div>
          <div class="mark cg-flex-shrink0">
            <img src="@/assets/slices/mark.png" alt />
          </div>
        </div>
        <div class="login-button pointer flex al-cn ju-en cg-flex-shrink0">
          <div class="cg-mr-40">
            <el-menu
              active-text-color="#78BA60"
              text-color="#000"
              :default-active="defaultActive"
              class="el-menu-demo menu"
              style="min-width: 380px"
              mode="horizontal"
              @select="handleSelect"
              :router="router"
            >
              <el-menu-item index="/Home">首页</el-menu-item>
              <el-menu-item index="/lease">写字楼租赁</el-menu-item>
              <el-menu-item index="/entrust">委托找房</el-menu-item>
              <el-menu-item index="/releaseOfHousing">投放房源</el-menu-item>
            </el-menu>
          </div>
          <img src="@/assets/slices/telephone.png" />
          <div class="text">咨询电话：</div>
          <div class="phone">400-176-0532</div>
        </div>
      </div>
    </el-header>
    <el-main style="margin-top: 62px">
      <router-view></router-view>
    </el-main>
    <div class="footer" v-show="isShow">
      <div class="footer-content flex ju-sp">
        <div class="flex">
          <ul class="content-nav">
            <img class="image_20" src="@/assets/slices/bottomLogo.png" alt />
          </ul>
          <div class="ml20 mt10">
            <ul class="content-nav">
              <li>
                <p class="pointer discolour-blue" @click="routerGo('/Home')">首页</p>
              </li>
              <li>
                <p class="pointer discolour-blue" @click="routerGo('/lease')">
                  写字楼租赁
                </p>
              </li>
              <li>
                <p class="pointer discolour-blue" @click="routerGo('/entrust?status=0')">
                  委托找房
                </p>
              </li>
              <li>
                <p class="pointer discolour-blue" @click="routerGo('/releaseOfHousing')">
                  投放房源
                </p>
              </li>
            </ul>
            <ul class="content-nav">
              <li>
                <div class="login-button pointer flex al-cn">
                  <img src="@/assets/slices/telephone.png" />
                  <div class="text">咨询电话：</div>
                  <div class="phone">400-176-0532</div>
                  <div class="text">地址：</div>
                  <div class="">青岛卓越世纪中心2号楼1509室</div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="public-account">
          <img src="@/assets/img/qrcode.png" alt />
          <div class="flex ju-cn">扫一扫，添加客服</div>
        </div>
      </div>
      <div class="copyright flex ju-cn">
        <img
          class="thumbnail_6"
          referrerpolicy="no-referrer"
          :src="require('@/assets/icon/img_ba.png')"
        />
        <div style="display: flex">
          <div>鲁ICP备2024061210号-1|2024-现在YUEJIALIANHANG.COM所有|</div>

          <p class="pointer discolour-blue" @click="routerGo('/about')">公司简介</p>
        </div>
      </div>
    </div>
  </el-container>
</template>

<script>
export default {
  data() {
    return {
      router: true,
      //路由激活
      defaultActive: "/Home",
      home: true,
      isShow: true,
      input: "",
    };
  },
  watch: {
    $route(val) {
      this.defaultActive = val.fullPath;
      this.home = this.defaultActive === "/Home";
    },
  },
  mounted() {
    this.defaultActive = this.$route.fullPath;
    this.home = this.defaultActive === "/Home";
  },
  methods: {
    handleSelect(key) {
      this.home = key === "/Home";
    },
    //路由跳转
    routerGo(path) {
      this.$router.push({ path: path });
    },
    loginIn() {
      this.$router.push({ name: "login" });
    },
  },
};
</script>

<style lang="scss">
.el-menu.el-menu--horizontal {
  border-bottom: solid 0px #ffffff;
}
.el-header {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  background-color: #fff;

  .logo {
    padding-right: 30px;

    img {
      // width: 100%;
      height: 65px;
    }
  }

  .mark {
    // padding-right: 210px;

    img {
      // width: 100%;
      height: 30px;
    }
  }
}
@media screen and (max-width: 1200px) {
  .mark {
    display: none;
  }
}
.login-button {
  font-family: SourceHanSansSC, SourceHanSansSC;
  display: flex;
  align-items: center;
  height: 100%;

  img {
    width: 26px;
    height: 26px;
  }

  .text {
    font-size: 16px;
    font-weight: 400;
    color: #000000;
    padding-left: 10px;
  }

  .phone {
    font-size: 20px;
    font-weight: bold;
    color: #6ebb53;
  }
}

.header {
  .buts {
    //border: 1px solid rgba(138, 138, 138, 0.68);
    border: 1px rgba(138, 138, 138, 0.68) solid;
  }
}

.el-main {
  padding: 0 !important;
}

.footer {
  width: 100%;
  overflow: hidden;
  border-top: 1px #e9e9e9 solid;
  //background-color: rgba(67, 67, 67, 1);

  &-content {
    // width: 1440px;
    margin: auto;
    padding: 30px 50px 15px 50px;

    .image_20 {
      width: 286px;
      height: 150px;
    }

    .icon {
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }

    .content-nav {
      display: flex;
      //justify-content: space-around;

      li {
        display: flex;
        flex-direction: column;
        padding-left: 50px;
        //justify-content: center;
        align-items: flex-start;
        font-weight: 400;

        p {
          //color: #fff;
          font-size: 18px;
          padding: 10px 0 20px;
        }
      }
    }

    .public-account {
      display: flex;
      flex-direction: column;
      //align-items: flex-start;
      justify-content: center;
      padding: 10px 20px;

      img {
        width: 155px;
        height: 155px;
        margin-bottom: 20px;
      }
    }
  }

  .copyright {
    border-top: 1px #e9e9e9 solid;
    height: 50px;
    padding-top: 25px;

    .thumbnail_6 {
      width: 19px;
      height: 19px;
      margin-right: 20px;
    }
  }
}
</style>
